import { Modal, Button, Form, Table, Stack, Col } from 'react-bootstrap';
import { useState, useEffect } from 'react';

const OralConditionButtonModal = ({ value = '', onSave, onOralConditionChange }) => {
  const [note, setNote] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [savedNote, setSavedNote] = useState(value);

  // Saat modal dibuka, isi teks area dengan savedNote
  useEffect(() => {
    if (showModal) {
      setNote(savedNote);
    }
  }, [showModal, savedNote]);

  // Jika value dari parent berubah (contohnya dikosongkan setelah handleAddClick), update internal state
  useEffect(() => {
    setSavedNote(value);  // update tampilan tabel
    setNote(value);       // update isian textarea
  }, [value]);

  const handleSave = () => {
    if (note.trim()) {
      setSavedNote(note);
      onSave(note);
      if (typeof onOralConditionChange === 'function') {
        onOralConditionChange(note);
      }
      setShowModal(false);
    }
  };


  return (
    <Col>
      <Stack>
        {savedNote ? (
          <Table
            bordered
            size="sm"
            className="mt-2 mb-0"
            style={{
              cursor: 'pointer',
              fontSize: '0.8rem',
              width: '100%',
              maxWidth: '100%',
              borderColor: '#dee2e6',
            }}
            onClick={() => setShowModal(true)}
          >
            <thead className="table-light">
              <tr>
                <th
                  style={{
                    padding: '4px 8px',
                    backgroundColor: '#dee2e6',
                    fontWeight: '600',
                    fontSize: '0.75rem',
                    textAlign: 'left',
                    color: '#343a40',
                  }}
                >
                  Kondisi Gigi dan Mulut Lainnya
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: '4px 8px', whiteSpace: 'pre-wrap' }}>
                  • {savedNote}
                </td>
              </tr>
            </tbody>
          </Table>
        ) : (
          <Button
            size="sm"
            onClick={() => setShowModal(true)}
            style={{
              width: '100%',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              fontSize: '0.75rem',
              lineHeight: '1rem',
              padding: '4px',
              backgroundColor: 'transparent',
              color: '#343a40',
              borderColor: '#ced4da',
              borderWidth: '1px',
              borderStyle: 'solid',
            }}
          >
            Kondisi Gigi dan Mulut Lainnya
          </Button>
        )}
      </Stack>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Kondisi Gigi dan Mulut Lainnya</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="oralConditionNote">
            <Form.Control
              as="textarea"
              rows={5}
              value={note}
              onChange={(e) => {
                const val = e.target.value;
                setNote(val);
                if (typeof onOralConditionChange === 'function') {
                  onOralConditionChange(val);
                }
              }}
              placeholder="sariawan, gigi berlubang, bau mulut dll"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Batal
          </Button>
          <Button
            variant="primary"
            onClick={handleSave}
            disabled={!note.trim()}
          >
            Simpan
          </Button>
        </Modal.Footer>
      </Modal>
    </Col>
  );
};

export default OralConditionButtonModal;
